/* ka-filters.js (R34 T32, spec D50 rows 2 and 3)
   Shop-page behavior shared by the collection page and search results:
     1. Filter panel: a <dialog> that slides in from the left at every width. Closes with the X,
        Escape, a click on the dim backdrop, or the sticky "Show N results" button (which applies).
     2. Live "Show N results": asks the section renderer for the filtered count.
     3. Sort: its own button that expands a list in place; picking an option sets sort_by in the URL
        and keeps every filter param.
     4. Price: one dual-handle range slider built from two native range inputs (keyboard works for free),
        written to filter.v.price.gte / filter.v.price.lte only when a handle leaves its end.

   Markup contract (see sections/ka-collection-page.liquid and sections/search-results.liquid):
     #ka-fpanel[data-section-id]  the dialog;  [data-ka-fpanel-open] opens it;  [data-ka-fpanel-close] closes it
     #ka-fpanel-form              the filter form (GET);  [data-ka-fpanel-apply] is the Show N results button
     [data-ka-range]              slider box with .ka-range__in--lo / --hi, hidden gte/lte inputs, <output> readouts
     [data-ka-sort]               sort box: [data-ka-sort-btn], [data-ka-sort-pop], links [data-sort]          */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Price slider ─────────────────────────────────────────── */
  function initRange(box) {
    var lo = box.querySelector('.ka-range__in--lo');
    var hi = box.querySelector('.ka-range__in--hi');
    var fill = box.querySelector('.ka-range__fill');
    var outLo = box.querySelector('[data-ka-range-lo]');
    var outHi = box.querySelector('[data-ka-range-hi]');
    var hidLo = box.querySelector('[data-ka-range-gte]');
    var hidHi = box.querySelector('[data-ka-range-lte]');
    if (!lo || !hi) return;
    var min = Number(lo.min), max = Number(lo.max);
    var span = Math.max(max - min, 1);
    function fmt(n) { return Number(n).toLocaleString('en-US'); }
    function sync(src) {
      var a = Number(lo.value), b = Number(hi.value);
      if (a > b) {
        if (src === lo) { a = b; lo.value = a; } else { b = a; hi.value = b; }
      }
      var pa = ((a - min) / span) * 100, pb = ((b - min) / span) * 100;
      fill.style.setProperty('--lo', pa);
      fill.style.setProperty('--hi', pb);
      outLo.textContent = fmt(a);
      outHi.textContent = fmt(b) + (b >= max ? '+' : '');
      hidLo.value = a > min ? a : '';
      hidHi.value = b < max ? b : '';
      lo.setAttribute('aria-valuetext', '$' + fmt(a));
      hi.setAttribute('aria-valuetext', '$' + fmt(b));
      /* when both handles sit together near the left end the hi handle must stay on top, and near the right end the lo handle */
      lo.style.zIndex = a > min + span / 2 ? 4 : 2;
      hi.style.zIndex = 3;
    }
    lo.addEventListener('input', function () { sync(lo); });
    hi.addEventListener('input', function () { sync(hi); });
    sync();
  }
  document.querySelectorAll('[data-ka-range]').forEach(initRange);

  /* ── Filter panel ─────────────────────────────────────────── */
  var dlg = document.getElementById('ka-fpanel');
  var form = document.getElementById('ka-fpanel-form');
  if (dlg && form && typeof dlg.showModal === 'function') {
    var apply = dlg.querySelector('[data-ka-fpanel-apply]');
    var openers = document.querySelectorAll('[data-ka-fpanel-open]');
    var lastOpener = null;
    var timer = null, ctl = null, closing = false;

    function formParams() {
      var p = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
      return p;
    }
    function finishClose() {
      dlg.classList.remove('ka-fpanel--closing');
      if (dlg.open) dlg.close();
      closing = false;
      document.documentElement.classList.remove('ka-lock');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastOpener) lastOpener.focus({ preventScroll: true });
    }
    function closePanel() {
      if (!dlg.open || closing) return;
      closing = true;
      if (reduceMotion) { finishClose(); return; }
      dlg.classList.add('ka-fpanel--closing');
      var done = false;
      function once() { if (done) return; done = true; finishClose(); }
      dlg.addEventListener('animationend', once, { once: true });
      setTimeout(once, 320);
    }
    function openPanel(btn) {
      if (dlg.open) return;
      lastOpener = btn;
      dlg.showModal();
      document.documentElement.classList.add('ka-lock');
      openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    }

    openers.forEach(function (b) { b.addEventListener('click', function () { openPanel(b); }); });
    dlg.querySelectorAll('[data-ka-fpanel-close]').forEach(function (b) { b.addEventListener('click', closePanel); });
    /* Escape: the browser would close at once with no exit animation, so it goes through closePanel */
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); closePanel(); });
    /* the dialog box is exactly the panel, so a click whose target is the dialog itself landed on the backdrop */
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closePanel(); });

    function refreshCount() {
      if (ctl) ctl.abort();
      ctl = window.AbortController ? new AbortController() : null;
      if (!apply) return;
      var p = formParams();
      p.set('section_id', dlg.dataset.sectionId);
      apply.textContent = 'Counting…';
      fetch(form.getAttribute('action') + '?' + p.toString(), { signal: ctl ? ctl.signal : undefined })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var m = html.match(/data-ka-total data-n="(\d+)"/);
          var n = m ? parseInt(m[1], 10) : null;
          if (n === null) { apply.textContent = 'Show results'; apply.disabled = false; return; }
          apply.disabled = n === 0;
          apply.textContent = n === 0 ? 'No results' : 'Show ' + n + (n === 1 ? ' result' : ' results');
        })
        .catch(function (err) { if (!err || err.name !== 'AbortError') apply.textContent = 'Show results'; });
    }
    form.addEventListener('change', function () {
      clearTimeout(timer);
      timer = setTimeout(refreshCount, 220);
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = formParams().toString();
      window.location.href = form.getAttribute('action') + (q ? '?' + q : '');
    });
  }

  /* ── Sort: its own button, list expands in place ──────────── */
  var sortBox = document.querySelector('[data-ka-sort]');
  if (sortBox) {
    var sBtn = sortBox.querySelector('[data-ka-sort-btn]');
    var sPop = sortBox.querySelector('[data-ka-sort-pop]');
    function sortOpen() { return !sPop.hidden; }
    function setSort(open, returnFocus) {
      sPop.hidden = !open;
      sBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      sortBox.classList.toggle('is-open', open);
      if (open) {
        var cur = sPop.querySelector('[aria-current="true"]') || sPop.querySelector('a');
        if (cur) cur.focus({ preventScroll: true });
      } else if (returnFocus) {
        sBtn.focus({ preventScroll: true });
      }
    }
    sBtn.addEventListener('click', function () { setSort(!sortOpen()); });
    sortBox.querySelectorAll('[data-ka-sort-close]').forEach(function (b) {
      b.addEventListener('click', function () { setSort(false, true); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sortOpen()) { setSort(false, true); }
    });
    document.addEventListener('click', function (e) {
      if (sortOpen() && !sortBox.contains(e.target)) setSort(false);
    });
    sPop.querySelectorAll('a[data-sort]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', a.dataset.sort);
        params.delete('page');
        window.location.search = params.toString();
      });
    });
  }
})();
